import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Input, Button, InputNumber, DatePicker, Upload, Icon, Tag, Tabs, notification, Row, Col, Typography, Switch, Carousel } from 'antd';
import { MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ApiCaller from '../../../utils/api-caller';
import Toast from 'antd-mobile/lib/toast';
import Format from '../../../utils/format';
import moment from 'moment';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Markup } from 'interweave';
import './updatespecialoffer.css';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../../admin/i18n/adminI18n';

const { Search, TextArea } = Input;
const { Text, Paragraph } = Typography;
const { TabPane } = Tabs;

@inject(
    'CmsLanguageStore',
    'webSettingStore',
    'specialOfferStore',
)
@observer
class UpdateSpecialOfferModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            uploading: false
        }
    }

    componentDidMount() {
        this.props.CmsLanguageStore.getActives();
        this.props.webSettingStore.getData();
    }

    // ON CLICK

    deleteBannerOnClick = () => {
        this.props.specialOfferStore.setImageUrl('');
    }

    useItemImageOnClick = () => {
        this.props.specialOfferStore.setImageUrlAsOriginalImageUrl();
    }

    createClicked = () => this.props.specialOfferStore.createSpecialOffer();
    updateClicked = () => this.props.specialOfferStore.updateSpecialOffer();
    cancelClicked = () => this.props.specialOfferStore.setShowUpdateSpecialOfferModal(false);

    // ON CHANGE

    titleChanged = (e) => this.props.specialOfferStore.setTitle(e.target.value);
    titleChineseChanged = (e) => this.props.specialOfferStore.setTitleChinese(e.target.value);
    titleChineseTraditionalChanged = (e) => this.props.specialOfferStore.setTitleChineseTraditional(e.target.value);
    titleThaiChanged = (e) => this.props.specialOfferStore.setTitleThai(e.target.value);
    titleJapaneseChanged = (e) => this.props.specialOfferStore.setTitleJapanese(e.target.value);
    titleArabicChanged = (e) => this.props.specialOfferStore.setTitleArabic(e.target.value);

    briefDescChanged = (e) => this.props.specialOfferStore.setBriefDesc(e.target.value);
    briefDescChineseChanged = (e) => this.props.specialOfferStore.setBriefDescChinese(e.target.value);
    briefDescChineseTraditionalChanged = (e) => this.props.specialOfferStore.setBriefDescChineseTraditional(e.target.value);
    briefDescThaiChanged = (e) => this.props.specialOfferStore.setBriefDescThai(e.target.value);
    briefDescJapaneseChanged = (e) => this.props.specialOfferStore.setBriefDescJapanese(e.target.value);
    briefDescArabicChanged = (e) => this.props.specialOfferStore.setBriefDescArabic(e.target.value);

    descriptionChanged = (data) => this.props.specialOfferStore.setDescription(data);
    descriptionChineseChanged = (data) => this.props.specialOfferStore.setDescriptionChinese(data);
    descriptionChineseTraditionalChanged = (data) => this.props.specialOfferStore.setDescriptionChineseTraditional(data);
    descriptionThaiChanged = (data) => this.props.specialOfferStore.setDescriptionThai(data);
    descriptionJapaneseChanged = (data) => this.props.specialOfferStore.setDescriptionJapanese(data);
    descriptionArabicChanged = (data) => this.props.specialOfferStore.setDescriptionArabic(data);

    priceChange = (value) => this.props.specialOfferStore.setPrice(value);
    showBannerOnlyOnChange = (value) => this.props.specialOfferStore.setShowBannerOnly(value);

    handleStartDateChange = (e) => this.props.specialOfferStore.setStartDate(e);
    handleStartTimeChange = (e) => this.props.specialOfferStore.setStartTime(e);
    handleEndDateChange = (e) => this.props.specialOfferStore.setEndDate(e);
    handleEndTimeChange = (e) => this.props.specialOfferStore.setEndTime(e);

    itemSearched = () => {
        this.props.specialOfferStore.setItemSearchValue('');
        this.props.specialOfferStore.searchItem('');
        this.props.specialOfferStore.setShowSearchMenuItemModal(true);
    }

    // UPLOAD Settings

    dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 0);
    }

    beforeUpload = (file, id) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
        if (!isJpgOrPng) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'You can only upload JPG/PNG file!',
                placement: 'bottomRight',
            })
        }

        const isLessThan10Mb = file.size / 1024 / 1024 <= 1;
        if (!isLessThan10Mb) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'Image must smaller or equal to 1MB!',
                placement: 'bottomRight',
            })
        }

        if (isJpgOrPng && isLessThan10Mb) {
            this.props.specialOfferStore.setImageIsLoadingById(id, true);
        }

        return isJpgOrPng && isLessThan10Mb
    }

    uploadChange = (info, id, title) => {
        if (info.file.status) {
            if (info.file.status === 'uploading') {
                this.props.specialOfferStore.setImageUrlById(id, '')
                return
            }
            if (info.file.status === 'done') {
                const category = 'SpecialOffer'
                const titleName = Format.RemoveSpecialChars(title) || 'Default'

                ApiCaller.Upload.apiUploadImages(info.file.originFileObj, category, titleName).then(response => {
                    this.props.specialOfferStore.setImageUrlById(id, response.imageUrl)
                    this.props.specialOfferStore.setImageIsLoadingById(id, false);
                })
            }
        }
    }

    isLanguageIdActive = (languageId) => {
        const { activeLanguages } = this.props.CmsLanguageStore;

        if (activeLanguages) {
            const language = activeLanguages.find(fi => fi.id === languageId);
            if (language) {
                return true;
            }
        }

        return false;
    }

    render() {
        const { t } = this.props;
        const { activeLanguages } = this.props.CmsLanguageStore;

        const { data: webSettting } = this.props.webSettingStore;

        const {
            specialOfferId,
            taskName,
            title,
            titleChinese,
            titleChineseTraditional,
            titleThai,
            titleJapanese,
            titleArabic,
            briefDesc,
            briefDescChinese,
            briefDescChineseTraditional,
            briefDescThai,
            briefDescJapanese,
            briefDescArabic,
            description,
            descriptionChinese,
            descriptionChineseTraditional,
            descriptionThai,
            descriptionJapanese,
            descriptionArabic,
            updateLoading,
            originalPrice,
            price,
            startDate,
            startTime,
            endDate,
            endTime,
            // imageUrl,
            images,
            // originalImageUrl,
            showBannerOnly,
            sort
        } = this.props.specialOfferStore;

        let hasError = true;

        if (showBannerOnly) {
            hasError = images.length > 1 &&
                taskName !== '' &&
                startDate !== null &&
                startTime !== null &&
                endDate !== null &&
                endTime !== null;
        } else {
            hasError = images.length > 1 &&
                taskName !== '' &&
                startDate !== null &&
                startTime !== null &&
                endDate !== null &&
                endTime !== null &&
                title !== '' &&
                briefDesc !== '' &&
                description !== '';
        }

        if (updateLoading) {
            Toast.loading(this.props.t ? this.props.t('Saving...') : 'Saving...', 100, null, true);
        } else {
            Toast.hide();
        }

        return (
            <>
                {
                    activeLanguages
                        ?
                        <>
                            <Form layout='vertical'>

                                <Form.Item label={t('Item Name')}>
                                    <Search
                                        placeholder={t('search item')}
                                        value={taskName}
                                        onSearch={() => this.itemSearched(true)}
                                        enterButton
                                    />
                                </Form.Item>

                                <>
                                    {
                                        images.map(image => {
                                            return (
                                                <Form.Item key={image.id} label={
                                                    image.url === ''
                                                        ?
                                                        t('Create Banner')
                                                        :
                                                        <>
                                                            <Row className='updatespecialoffer-row-label'>
                                                                <Col span={18} className='updatespecialoffer-col-label'>{t('Update Banner')}</Col>
                                                                <Col span={6} className='updatespecialoffer-col-label-button'>
                                                                    <Button type='danger' onClick={() => this.props.specialOfferStore.removeImageById(image.id)}>{t('Delete')}</Button>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                }>
                                                    <Upload
                                                        listType='picture-card'
                                                        className='avatar-uploader'
                                                        showUploadList={false}
                                                        customRequest={this.dummyRequest}
                                                        beforeUpload={(info) => this.beforeUpload(info, image.id)}
                                                        onChange={(info) => this.uploadChange(info, image.id, title)}
                                                    >
                                                        {
                                                            image.url !== ''
                                                                ?
                                                                <img src={image.url} alt='avatar' className='updatespecialoffer-img' />
                                                                :
                                                                <div>
                                                                    <Icon type={image.isLoading ? 'loading' : 'plus'} />
                                                                    <div className='ant-upload-text'>{t('Upload')}</div>
                                                                </div>}
                                                    </Upload>
                                                </Form.Item>
                                            )
                                        })
                                    }
                                </>

                                <Form.Item label={t('Show Banner Only')}>
                                    <Switch checkedChildren={t('Yes')} unCheckedChildren={t('No')} checked={showBannerOnly} onChange={this.showBannerOnlyOnChange} />
                                </Form.Item>

                                <Form.Item label={t('Sort')}>
                                    <InputNumber
                                        className='stm-width-100'
                                        value={sort}
                                        onChange={(value) => this.props.specialOfferStore.setsort(value)}
                                        min={0}
                                    />
                                </Form.Item>

                                <React.Fragment>
                                    {
                                        showBannerOnly
                                            ?
                                            null
                                            :
                                            <Tabs defaultActiveKey='1'>
                                                {/* English */}
                                                {
                                                    this.isLanguageIdActive(1)
                                                        ?
                                                        <TabPane tab='English *' key='1'>
                                                            <Form.Item label={t('Title')} className='mg-b-10'>
                                                                <Input placeholder={t('Insert title')} value={title} onChange={this.titleChanged} />
                                                            </Form.Item>
                                                            <Form.Item label={t('Brief Description (Max. 100 characters)')} className='mg-b-10'>
                                                                <TextArea rows={3} maxLength={100} placeholder={t('Insert brief description')} value={briefDesc} onChange={this.briefDescChanged}></TextArea>
                                                            </Form.Item>
                                                            <Form.Item label={t('Description')} className='mg-b-10'>
                                                                <CKEditor
                                                                    editor={ClassicEditor}
                                                                    data={description}
                                                                    onChange={(event, editor) => {
                                                                        const data = editor.getData();
                                                                        this.descriptionChanged(data);
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </TabPane>
                                                        :
                                                        null
                                                }

                                                {/* Chinese */}
                                                {
                                                    this.isLanguageIdActive(2)
                                                        ?
                                                        <TabPane tab='简体中文' key='2'>
                                                            <Form.Item label={t('Title')} className='mg-b-10'>
                                                                <Input placeholder={t('Insert title')} value={titleChinese} onChange={this.titleChineseChanged} />
                                                            </Form.Item>
                                                            <Form.Item label={t('Brief Description (Max. 100 characters)')} className='mg-b-10'>
                                                                <TextArea rows={3} maxLength={100} placeholder={t('Insert brief description')} value={briefDescChinese} onChange={this.briefDescChineseChanged}></TextArea>
                                                            </Form.Item>
                                                            <Form.Item label={t('Description')} className='mg-b-10'>
                                                                <CKEditor
                                                                    editor={ClassicEditor}
                                                                    data={descriptionChinese}
                                                                    onChange={(event, editor) => {
                                                                        const data = editor.getData();
                                                                        this.descriptionChineseChanged(data);
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </TabPane>
                                                        :
                                                        null
                                                }

                                                {/* Chinese Traditional */}
                                                {
                                                    this.isLanguageIdActive(3)
                                                        ?
                                                        <TabPane tab='繁體中文' key='3'>
                                                            <Form.Item label={t('Title')} className='mg-b-10'>
                                                                <Input placeholder={t('Insert title')} value={titleChineseTraditional} onChange={this.titleChineseTraditionalChanged} />
                                                            </Form.Item>
                                                            <Form.Item label={t('Brief Description (Max. 100 characters)')} className='mg-b-10'>
                                                                <TextArea rows={3} maxLength={100} placeholder={t('Insert brief description')} value={briefDescChineseTraditional} onChange={this.briefDescChineseTraditionalChanged}></TextArea>
                                                            </Form.Item>
                                                            <Form.Item label={t('Description')} className='mg-b-10'>
                                                                <CKEditor
                                                                    editor={ClassicEditor}
                                                                    data={descriptionChineseTraditional}
                                                                    onChange={(event, editor) => {
                                                                        const data = editor.getData();
                                                                        this.descriptionChineseTraditionalChanged(data);
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </TabPane>
                                                        :
                                                        null
                                                }

                                                {/* Thai */}
                                                {
                                                    this.isLanguageIdActive(4)
                                                        ?
                                                        <TabPane tab='ไทย' key='4'>
                                                            <Form.Item label={t('Title')} className='mg-b-10'>
                                                                <Input placeholder={t('Insert title')} value={titleThai} onChange={this.titleThaiChanged} />
                                                            </Form.Item>
                                                            <Form.Item label={t('Brief Description (Max. 100 characters)')} className='mg-b-10'>
                                                                <TextArea rows={3} maxLength={100} placeholder={t('Insert brief description')} value={briefDescThai} onChange={this.briefDescThaiChanged}></TextArea>
                                                            </Form.Item>
                                                            <Form.Item label={t('Description')} className='mg-b-10'>
                                                                <CKEditor
                                                                    editor={ClassicEditor}
                                                                    data={descriptionThai}
                                                                    onChange={(event, editor) => {
                                                                        const data = editor.getData();
                                                                        this.descriptionThaiChanged(data);
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </TabPane>
                                                        :
                                                        null
                                                }

                                                {/* Japanese */}
                                                {
                                                    this.isLanguageIdActive(5)
                                                        ?
                                                        <TabPane tab='日本' key='5'>
                                                            <Form.Item label={t('Title')} className='mg-b-10'>
                                                                <Input placeholder={t('Insert title')} value={titleJapanese} onChange={this.titleJapaneseChanged} />
                                                            </Form.Item>
                                                            <Form.Item label={t('Brief Description (Max. 100 characters)')} className='mg-b-10'>
                                                                <TextArea rows={3} maxLength={100} placeholder={t('Insert brief description')} value={briefDescJapanese} onChange={this.briefDescJapaneseChanged}></TextArea>
                                                            </Form.Item>
                                                            <Form.Item label={t('Description')} className='mg-b-10'>
                                                                <CKEditor
                                                                    editor={ClassicEditor}
                                                                    data={descriptionJapanese}
                                                                    onChange={(event, editor) => {
                                                                        const data = editor.getData();
                                                                        this.descriptionJapaneseChanged(data);
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </TabPane>
                                                        :
                                                        null
                                                }

                                                {/* Arabic */}
                                                {
                                                    this.isLanguageIdActive(8)
                                                        ?
                                                        <TabPane tab='العربية' key='8'>
                                                            <Form.Item label={t('Title')} className='mg-b-10'>
                                                                <Input placeholder={t('Insert title')} value={titleArabic} onChange={this.titleArabicChanged} />
                                                            </Form.Item>
                                                            <Form.Item label={t('Brief Description (Max. 100 characters)')} className='mg-b-10'>
                                                                <TextArea rows={3} maxLength={100} placeholder={t('Insert brief description')} value={briefDescArabic} onChange={this.briefDescArabicChanged}></TextArea>
                                                            </Form.Item>
                                                            <Form.Item label={t('Description')} className='mg-b-10'>
                                                                <CKEditor
                                                                    editor={ClassicEditor}
                                                                    data={descriptionArabic}
                                                                    onChange={(event, editor) => {
                                                                        const data = editor.getData();
                                                                        this.descriptionArabicChanged(data);
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </TabPane>
                                                        :
                                                        null
                                                }
                                            </Tabs>
                                    }
                                </React.Fragment>

                                <div style={{ borderBottom: '2px solid #1890ff', marginBottom: 20 }} />

                                <Form.Item label={t('Original Price')}>
                                    <Tag color={'blue'} style={{ fontSize: 14, padding: '5px 15px 5px 15px' }}>
                                        {webSettting ? webSettting.currencyCode : ''} {Format.Currency(originalPrice)}
                                    </Tag>
                                </Form.Item>

                                <Form.Item label={t('Special Price')}>
                                    <InputNumber
                                        value={price}
                                        onChange={this.priceChange}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        style={{ width: '100%' }}
                                    />
                                </Form.Item>

                                <Form.Item label={t('Start Date Time')}>
                                    <DatePicker
                                        size='default'
                                        style={{ width: '65%', marginRight: 12 }}
                                        format='DD MMM YYYY'
                                        value={startDate}
                                        onChange={(e) => this.handleStartDateChange(e)}
                                    />
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardTimePicker
                                            margin='dense'
                                            ampm={false}
                                            id='startdatetime-picker'
                                            style={{ width: '30%', marginRight: 5, marginLeft: 5, top: -12 }}
                                            value={startTime}
                                            onChange={(e) => this.handleStartTimeChange(e)}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change time',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Form.Item>

                                <Form.Item label={t('End Date Time')}>
                                    <DatePicker
                                        size='default'
                                        style={{ width: '65%', marginRight: 12 }}
                                        format='DD MMM YYYY'
                                        value={endDate}
                                        onChange={(e) => this.handleEndDateChange(e)}
                                    />
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardTimePicker
                                            margin='dense'
                                            ampm={false}
                                            id='enddatetime-picker'
                                            style={{ width: '30%', marginRight: 5, marginLeft: 5, top: -12 }}
                                            value={endTime}
                                            onChange={(e) => this.handleEndTimeChange(e)}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change time',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Form.Item>

                                <Form.Item label={t('Preview Banner')}>
                                    <Row>
                                        <Col span={24} className='updatespecialoffer-col-preview-container'>
                                            {
                                                images.length === 1
                                                    ?
                                                    null
                                                    :
                                                    <Row>
                                                        <Col className='updatespecialoffer-col-preview-img'>
                                                            <Row>
                                                                <Col
                                                                    span={24}
                                                                    className={images.length === 2 ? 'updatespecialoffer-col-carousel-container-single' : 'updatespecialoffer-col-carousel-container'}
                                                                >
                                                                    <Carousel>
                                                                        {
                                                                            images.filter(fi => fi.url !== '').map(image => {
                                                                                return (
                                                                                    <div key={image.id} className='updatespecialoffer-div-carousel'>
                                                                                        <Row className='updatespecialoffer-row-carousel'>
                                                                                            <Col span={24} className='updatespecialoffer-col-carousel'>
                                                                                                <img className='updatespecialoffer-img-carousel' src={image.url} alt={image.id} />
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </div>
                                                                                )
                                                                            })
                                                                        }
                                                                    </Carousel>
                                                                </Col>
                                                            </Row>
                                                            <React.Fragment>
                                                                {
                                                                    showBannerOnly
                                                                        ?
                                                                        null
                                                                        :
                                                                        <Row className='updatespecialoffer-row-detail'>
                                                                            <Col span={24} className='updatespecialoffer-col-preview-title'>
                                                                                <Text className='updatespecialoffer-text-preview-title'>{title}</Text>
                                                                            </Col>
                                                                            <Col span={24} className='updatespecialoffer-col-preview-date'>
                                                                                <Row>
                                                                                    <Col span={11} className='txt-algn-right'>
                                                                                        <Tag color={'blue'} className='fnt-8 mg-0' style={{ padding: '5px 15px 5px 15px' }}>
                                                                                            <Text>{moment(startDate).format("DD MMMM YYYY")}</Text>
                                                                                        </Tag>
                                                                                    </Col>
                                                                                    <Col span={2} className='txt-algn-center'>
                                                                                        <Text>-</Text>
                                                                                    </Col>
                                                                                    <Col span={11}>
                                                                                        <Tag color={'blue'} className='fnt-8' style={{ padding: '5px 15px 5px 15px' }}>
                                                                                            <Text>{moment(endDate).format("DD MMMM YYYY")}</Text>
                                                                                        </Tag>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                            <Paragraph className='clr-theme-dark-1 fnt-8 txt-algn-center'>
                                                                                <Text delete>
                                                                                    <Tag color={'red'} className='fnt-8' style={{ padding: '5px 15px 5px 15px', borderRadius: 50 }}>
                                                                                        <Text delete>{webSettting ? webSettting.currencyCode : ''} {Format.Currency(originalPrice)}</Text>
                                                                                    </Tag>
                                                                                </Text>
                                                                            </Paragraph>
                                                                            <Paragraph className='clr-theme-dark-1 fnt-10 txt-algn-center'>
                                                                                <Text>
                                                                                    <Tag color={'green'} className='fnt-10' style={{ padding: '5px 15px 5px 15px', borderRadius: 50 }}>
                                                                                        {webSettting ? webSettting.currencyCode : ''} {price ? Format.Currency(price) : ''}
                                                                                    </Tag>
                                                                                </Text>
                                                                            </Paragraph>
                                                                            <Paragraph className='clr-theme-dark-1'>
                                                                                <Markup content={briefDesc} />
                                                                            </Paragraph>
                                                                            <Paragraph className='clr-theme-dark-1'>
                                                                                <Markup content={description} />
                                                                            </Paragraph>
                                                                        </Row>
                                                                }
                                                            </React.Fragment>
                                                        </Col>
                                                    </Row>
                                            }
                                        </Col>
                                    </Row>
                                </Form.Item>

                                <Form.Item>
                                    {
                                        specialOfferId === 0 ? (
                                            <Button onClick={this.createClicked} style={{ marginRight: 10 }} type='primary' disabled={!hasError}>{t('Create')}</Button>
                                        ) : (
                                            <Button onClick={this.updateClicked} style={{ marginRight: 10 }} type='primary' disabled={!hasError}>{t('Update')}</Button>
                                        )
                                    }

                                    <Button onClick={this.cancelClicked}>{t('Cancel')}</Button>
                                </Form.Item>
                            </Form>
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(UpdateSpecialOfferModal);